import { render, staticRenderFns } from "./Help.icon.vue?vue&type=template&id=45012fed&"
import script from "./Help.icon.vue?vue&type=script&lang=js&"
export * from "./Help.icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports